// @flow
import React from 'react';
// import ReactDOM from 'react-dom';
import {
  FontAwesomeIcon as FontAwesome
} from '@fortawesome/react-fontawesome';
import {
  faSyncAlt
} from '@fortawesome/free-solid-svg-icons'

export default class Loading extends React.Component<*>{

  render() {
    if (this.props.error) {
      console.log(this.props.error)
      return <div>ERROR</div>
    }
    return (
      <div style={{ width: '100%', height: '100%', textAlign: 'center', padding: '50px', color: 'gray' }}>
        <FontAwesome
          icon={faSyncAlt}
          size='5x'
          spin={true}
          style={{ textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)' }}
        />
        {/* <FontAwesome icon="sync" /> */}
      </div>


    )
  }
}